<template>
  <div class="container">
    <PublicHeader :totalName="$t('common').Activecenter" />
    <!-- 邀请分佣 -->
    <div class="item" v-if="systemSetting.isCommission" @click="$router.push({ name: 'InviteReward' })">
      <svg-icon class-name="svgs" icon-class="share" />
      <div class="right">
        <div class="title"> {{ $t('activity.inviteTxt', { amount: systemSetting.commission1 }) }}</div>
        <div class="lable"> <span>{{ $t('activity').invitebtn }}</span></div>
      </div>
    </div>
    <!-- 充值分佣 -->
    <div class="item" v-if="systemSetting.isRechargeReward" @click="$router.push({ name: 'RechargeReward' })">
      <svg-icon class-name="svgs" icon-class="recharge_currency" />
      <div class="right">
        <div class="title">{{ $t('activity.rechargeTxt', { amount: systemSetting.rechargeReward1 }) }}</div>
        <div class="lable"> <span>{{ $t('activity').rechargebtn }}</span></div>
      </div>
    </div>
    <!-- 实名认证 -->
    <div class="item" v-if="systemSetting.isAuthReward" @click="$router.push({ name: 'AuthReward' })">
      <svg-icon class-name="svgs" icon-class="auth" />
      <div class="right">
        <div class="title">{{ $t('activity.authTxt', { amount: systemSetting.authReward }) }}</div>
        <div class="lable"> <span>{{ $t('activity').authbtn }}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import systemApi from '@/api/system'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      systemSetting: {}
    }
  },

  mounted() {
    this.getConfig()
  },
  methods: {
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      this.systemSetting = res.systemSetting
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding: 60px 15px 15px 15px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid var(--info_color);
    border-radius: 15px;

    .svgs {
      width: 40px;
      height: 40px;
      color: var(--text_color);
    }

    .right {
      width: calc(100% - 20px);
      margin-left: 20px;

      .title {
        font-size: 14px;
        font-weight: bold;
        line-height: 1.7;
        color: var(--text_color);
      }

      .lable {
        margin-top: 10px;

        span {
          font-size: 12px;
          color: rgba(2, 156, 92, 1);
          padding: 2px 5px;
          border: 1px solid rgba(2, 156, 92, 0.3);
          border-radius: 7px;
        }

      }
    }
  }
}
</style>
